import { createORPCClient } from "@orpc/client";
import { RPCLink as FetchLink } from "@orpc/client/fetch";
import type { RouterClient } from "@orpc/server";
import { createTanstackQueryUtils } from "@orpc/tanstack-query";

import type { API } from "./server";

const httpLink = new FetchLink({
	url: new URL("/rpc", window.location.origin).href,
	fetch: (input, init) => fetch(input, { ...init, credentials: "include" }),
});

const httpClient: RouterClient<API> = createORPCClient(httpLink);

export const orpc = createTanstackQueryUtils(httpClient);
